import Vue from 'vue';
import Fragment from 'vue-fragment';
import * as VueGoogleMaps from 'vue2-google-maps';
import { TooltipPlugin, AlertPlugin, CollapsePlugin, ModalPlugin } from 'bootstrap-vue';  // ui plugins
import store from '../store/map-filter';

Vue.use(Fragment.Plugin);

// init ui plugins add/remove as needed
Vue.use(AlertPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);
Vue.use(ModalPlugin);

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyD-f3pLQfEkAm9g6i1Qk6qM_d2g5445aTc',
		libraries: 'places', // This is required if you use the Autocomplete plugin
	},
});

// init app
const VueApp = new Vue({
    store,
});

export { VueApp as default };